<template>
  <div style="position: relative; width: 100%; height: auto">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-if="latestNews.length > 0">
          <template v-for="(list, index) in latestNews" :key="index">
            <component
              :is="
                list.length !== pageSize
                  ? 'universalList'
                  : index - 1 === -1 && show.topBar
                  ? 'defaultBar'
                  : `bar${(index - (show.topBar ? 1 : 0))
                      .toString()
                      .substr(-1)}`
              "
              :list="list"
              transition-mode="out-in"
            />
          </template>
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  onMounted,
  onBeforeUnmount,
  watch
} from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/hitech/MainBar";
import FirstBar from "@/components/hitech/FirstBar";
import SecondBar from "@/components/hitech/SecondBar";
import ThirdBar from "@/components/hitech/ThirdBar";
import FourthBar from "@/components/hitech/FourthBar";
import FivthBar from "@/components/hitech/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      topBar: true,
      spinner: true
    });

    const { i18n } = useLanguage();


    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 4;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'hi-tech',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const checkWidth = () => {
      show.topBar = window.innerWidth >= 767;
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData();

    watch(() => i18n.global.locale.value, refreshData);

    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      window.addEventListener("deviceorientation", resizeThrottler, true);
      resizeThrottler();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
      window.removeEventListener("deviceorientation", resizeThrottler);
    });

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  --width-content: 90%;

  width: 100%;
  position: relative;
  font-size: calc(max(16px, 0.8vw));

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;

    :deep() .card {
      &__title {
        font-family: 'Noto Serif', serif;
        font-weight: 500;
      }
      &__category {
        color: rgba(205, 205, 205, 0.5);
        font-weight: bold;
        font-size: 1em;
      }
      &__img {
        .img {
          border-radius: 0px;
          img {
            border-radius: 0px;
          }
        }
      }
      &__brief {
        font-weight: normal;
      }

      .data-news {
        color: rgba(205, 205, 205, 0.5);
        font-family: Roboto;
        font-size: 1em;
        line-height: 1.1;
      }
      @media screen and (max-width: 992px) {
        &__title {
          font-size: 1em;
        }
        &__category {
          font-size: 0.88em;
          line-height: 1.5;
        }
        .data-news {
          font-size: 0.8em;
          line-height: 1.5;
        }
      }
      @media screen and (max-width: 767px) {
        .data-news {
          font-size: 0.88em;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
